
      import Fullscreen from './fullscreen.vue'
      import type { App, Plugin } from 'vue'

      export const FullscreenPlugin: Plugin = {
        install(app: App) {
          app.component('Fullscreen', Fullscreen)
        },
      }
      export { Fullscreen }
      